import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const exportCsvDateFormat = "YYYY-MM-DD";
export const auditDateTimeFormat = "MMM DD YYYY hh:mm:ss A";

export function formatDateTime(datetime: any): string {
  return dayjs.utc(datetime).local().format(auditDateTimeFormat); // Convert and format the datetime to local time system
}
